import { Grid } from '@mui/material';
import { SlideParagraph, SlideTitle } from 'features/slides';
import { CaseMilestoneAction } from 'pages/Cases/hooks/useGetCases';
import React from 'react';
import { ModelSetsTable } from '../components/model-sets-table';

export type ModelSetProps = {
  readonly name: string;
  readonly action: CaseMilestoneAction;
  readonly options: number[];
};

export function ModelSet({
  name,
  action,
  options,
}: ModelSetProps): React.ReactElement {
  return (
    <Grid
      container
      flexDirection="column"
      gap={0}
      sx={{ width: '100%', padding: '10px' }}
    >
      <Grid
        container
        sx={{
          marginBottom: '6px',
        }}
      >
        <SlideTitle>{name}</SlideTitle>
      </Grid>

      <Grid container>
        {action && name ? (
          <ModelSetsTable
            action={action}
            modelSetName={name}
            options={options}
          />
        ) : null}
      </Grid>
      <SlideParagraph
        style={{
          marginBottom: '10px',
          marginTop: '10px',
          fontSize: '13px',
        }}
      >
        Source: TIFIN Sage
      </SlideParagraph>
    </Grid>
  );
}
